import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

type Variables = {
  key: string
  plantCode: string
  materialId: number
  pxTrendCounters?: string[]
  globalMaterialId?: number
}

export const useEditMaterialAttribute = ({
  onError,
  onSuccess,
  onSettled
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: void, variables: Variables) => void
  onSettled?: (data: void | undefined, error: AxiosError | null, variables: Variables) => void
} = {}) =>
  useMutation<void, AxiosError, Variables>({
    mutationFn: async ({plantCode, materialId, key, pxTrendCounters, globalMaterialId}) => {
      await ApiClient.axiosInstance.patch<void>(
        `/plants/${plantCode}/materials/${materialId}/${key}`,
        {pxTrendCounters, globalMaterialId}
      )
    },
    onError,
    onSuccess,
    onSettled
  })
